import { SxProps } from '@mui/material';

export const BenefitItemContentSX = () =>
	({
		// display: 'flex',
		// flexDirection: 'row',
		// alignItems: 'center',
		// padding: '0',
		// border: '1px solid #2682E7',
		// borderRadius: '4px',
		// width: '100%',
		// height: '140px',
		// justifyContent: 'center',
		// marginRight: '20px',
	} as SxProps);

export const BenefitImgContainerSX = () =>
	({
		// display: 'flex',
		// justifyContent: 'center',
		// marginTop: '10px',
		// marginBottom: '8px',
		// marginRight: '6px',
		width: '100%',
	} as SxProps);

export const BenefitItemTitleSX = () =>
	({
		fontWeight: 'normal',
		fontSize: 'var(--font-size-body)',
		color: '#2C2C2C',
		textAlign: 'left',
		marginBottom: '4px',
		textDecoration: 'underline',
	} as SxProps);

export const BenefitIDividerSX: SxProps = {
	marginLeft: '16px',
	marginRight: '16px',
};
